var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type-radio-component"},[_vm._l((_vm.list),function(item,index){return [_c('div',{key:index,class:['item',item.key === _vm.active?'active':''],attrs:{"disabled":item.disabled},on:{"click":function($event){return _vm.itemClick(item)}}},[_vm._v(_vm._s(item.name))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }